import Stack from '@ui/layout/Stack';
import { USER_OPTIONS } from '@/utils/userOptions';
import EpisodeEditFormPrivacyPrivacyField from '@app/organisms/EpisodeEditForm/EpisodeEditFormPrivacy/EpisodeEditFormPrivacyPrivacyField';
import EpisodeEditFormPrivacyDownloadField from '@app/organisms/EpisodeEditForm/EpisodeEditFormPrivacy/EpisodeEditFormPrivacyDownloadField';
import { useEpisodeBeingEdited } from '@app/organisms/EpisodeEditForm/EpisodeEditFormContext';
import NextStepButton from '@app/organisms/EpisodeEditForm/NextStepButton';

const EpisodeEditFormPrivacy = () => {
    const episode = useEpisodeBeingEdited();

    return (
        <Stack $gap="2rem">
            <EpisodeEditFormPrivacyPrivacyField
                isUnlistedAllowed={episode.show.userOptions.includes(
                    USER_OPTIONS.PODCASTS_UNLISTED,
                )}
            />
            <EpisodeEditFormPrivacyDownloadField />
            <NextStepButton />
        </Stack>
    );
};

export default EpisodeEditFormPrivacy;
